import { EntityWithStatusService } from './EntityWithStatusService';
import { IZCoreLocation, IEntityChildren } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class ZCoreLocationService extends EntityWithStatusService<IZCoreLocation> {
    constructor() {
        super(`/ZCoreLocations`);
    }

    public countAllOpenEntities(): Promise<IZCoreLocation[]> {
        return this.readAll(
            `?$select=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + ` and EntityStatusID eq ${EntityStatus.Open}`
        );
    }

    public readAllForList(includeClosed?: boolean): Promise<IZCoreLocation[]> {
        return this.readAll(
            `?$select=ID,Title,City,StateRegion,Country`
            + `&$orderby=Title`
            + `&$expand=EntityStatus($select=Title)&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public readAllForLookup(includeClosedEntities?: boolean, additionalFields?: string): Promise<IZCoreLocation[]> {
        return this.readAll(
            `?$select=ID,Title${additionalFields ? `,${additionalFields}` : ''}`
            + `&$orderby=Title&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosedEntities ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
        );
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const projects = (await this.axiosGet(`${entityUrl}/Projects?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Projects', CanBeAdopted: false, ChildIDs: (await projects).map((m: { ID: any }) => m.ID) },
        ];
    }

}